import styled from "styled-components";

export const StyledSearch = styled.input`
  margin-right: 1rem;
`;
